import EndpointConnection from "../Endpoint";
import FirewallConnection from "../Firewall";
import CloudConnection from "../Cloud";
import LogConnection from "../Log";
import MobileConnection from "../Mobile";
import IdentityConnection from "../Identity";
import AuthpointConnection from "../Authpoint";
import { isMDRTotal } from '../../../util/userControl';
import { abbreviateNumber, formatTimeAgo } from "../../../util/format";

export const connectionsConfig = [
  EndpointConnection,
  FirewallConnection,
  CloudConnection,
  IdentityConnection,
  LogConnection,
  MobileConnection
]

export const connectionsConfigWatchguard = [
  EndpointConnection,
  CloudConnection,
]

export const connectionsConfigMdrTotal = [
  EndpointConnection,
  FirewallConnection,
  CloudConnection,
  AuthpointConnection,
]

export const mobileConnectionsConfig = [
  MobileConnection,
  LogConnection,
  EndpointConnection,
  FirewallConnection,
  CloudConnection,
  IdentityConnection
]

export const mdrLiteConnectionsConfig = [
  EndpointConnection,
  CloudConnection,
  IdentityConnection,
  MobileConnection,
  LogConnection,
  FirewallConnection
]

export function getConnectionsConfig(userData) {
  const isWatchguard = userData?.tenantConfig?.is_watchguard;
  const isMDRLite = userData?.tenantConfig?.is_mdr_lite;
  const isMobileOnly = userData?.tenantConfig?.is_mobile_edr_only;

  if (isMobileOnly) return mobileConnectionsConfig;
  if (isMDRLite) return mdrLiteConnectionsConfig;
  if (isWatchguard){
    const isMdrTotal = isMDRTotal(userData);
    return isMdrTotal? connectionsConfigMdrTotal : connectionsConfigWatchguard;
  };
  return connectionsConfig;
}

const coreMdrClouds = ["o365"];
const totalMdrClouds = ["o365", "aws", "gsuite"];
const allClouds = ["aws", "gsuite", "o365", "salesforce"];

export function getCloudCardConfig(userData) {
  const isWatchguard = userData?.tenantConfig?.is_watchguard;
  if (isWatchguard) {
    const isMdrTotal = isMDRTotal(userData);
    return isMdrTotal ? totalMdrClouds : coreMdrClouds;
  }
  return allClouds;
}

export function getTableHeaderConfig(isTotalMdr = false) {
  const config = {
    "IP ADDRESS": {"field": "ip-address", "header": "IP ADDRESS", "sort": true, "defaultSortValue": false},
    "STATUS": {"field": "status", "header": "STATUS", "sort": false, "defaultSortValue": false},
    "VENDOR": {"field": "label", "header": "VENDOR", "sort": true, "defaultSortValue": false},
    "LAST SEEN": {"field": "last-seen", "header": "LAST SEEN", "sort": true, "defaultSortValue": false},
    "TOTAL EVENTS": {"field": "total-events", "header": "TOTAL EVENTS", "sort": true, "defaultSortValue": false},
    "COMMENTS": {"field": "comment", "header": "COMMENTS", "sort": false, "defaultSortValue": false},
  };

  if (isTotalMdr) {
    delete config["TOTAL EVENTS"];
  }

  return config;
}

export const firewallModalRadios = [
  {
    name: "onboarding",
    value: "Onboarded Firewalls",
    tooltip: "List of firewall IPs that have been updated in the onboarding page."
  },
  {
    name: "non-onboarding",
    value: "Non-Onboarded Syslog IPs",
    tooltip: "List of your infrastructure IP's sending syslog data seen in our pipeline."
  }
]

export function getFirewallDataMapping(isTotalMdr = false) {
  const mapping = {
    "Last Seen": { field: 'last_seen' },
    "Events": { field: 'total_events' },
    "Investigations": { field: 'investigation_count' },
    "Last Monthly Scan": { field: "last_monthly_scan" },
    "Most Recent Scan": { field: "most_recent_scan" }
  };

  if (isTotalMdr) {
    delete mapping["Events"];
    delete mapping["Last Monthly Scan"];
    delete mapping["Most Recent Scan"];
  }

  return mapping;
}

export const mapAuthpointValues = [
  { label: "Last Updated", field: "last_seen", formatter: formatTimeAgo },
  {
    label: "Investigations",
    field: "investigation_count",
    formatter: (value) => abbreviateNumber(value, 0),
  },
];
